import { FC, ReactNode } from "react"
import styled from "styled-components"

import CloseButton from "./buttons/CloseButton"

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${(props) => props.theme.zIndex.videoControls};
`

const ClickAway = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
`

const ModalCard = styled.div`
  position: relative;

  max-width: calc(100% - 28px);
  max-height: calc(100% - 28px);
  overflow-y: auto;

  border-radius: 2px;
  background-color: ${(props) => props.theme.colors.white};
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
`

const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
`

export type ModalProps = {
  closeModal: () => void
  children: ReactNode
}

const FullscreenModal: FC<ModalProps> = ({ closeModal, children }) => (
  <Wrapper>
    <ClickAway onClick={closeModal} />
    <ModalCard>
      <CloseButtonWrapper>
        <CloseButton showHoverStyles onClose={closeModal} size={15} />
      </CloseButtonWrapper>
      {children}
    </ModalCard>
  </Wrapper>
)

export default FullscreenModal
